import React from 'react';

import classes from './OfflineCoachRow.module.scss';
import { GridTableRow } from '../../../../../../../shared/components/table-components';
import { Coach } from '../../../../../../interfaces/coachList/CoachListInfo';
import { CoachInfoDesktop } from './CoachInfoDesktop/CoachInfoDesktop';
import { CoachInfoMobile } from './CoachInfoMobile/CoachInfoMobile';
import { SelectableCard } from '../../../../../../../shared/components/form-components';

type OfflineCoachRowProps = {
  coach: Coach;
  selectedCoachId?: number | null;
  onClick: (coach: Coach) => void;
  isMobile: boolean;
};

const OfflineCoachRow = ({
  coach,
  selectedCoachId,
  onClick,
  isMobile,
}: OfflineCoachRowProps) => {
  const checked = selectedCoachId === coach.coachId;

  const handleClick = () => {
    onClick(coach);
  };

  return (
    <SelectableCard
      variant="outBox"
      className={classes.container}
      onClick={handleClick}
      dataTestId="coach-row"
    >
      <GridTableRow className={classes.row} customLayout={isMobile} variant="unstyled">
        {isMobile ? (
          <CoachInfoMobile coach={coach} checked={checked} />
        ) : (
          <CoachInfoDesktop coach={coach} checked={checked} />
        )}
      </GridTableRow>
    </SelectableCard>
  );
};

export { OfflineCoachRow };
